import React, {useContext, useEffect, useState} from "react";
import {ContractsContext, Web3Context} from "../contexts/Context";
import Event from "../components/Event";
import Container from "react-bootstrap/Container";
import Logger from "../components/utils/Logger";

const Events = () => {
  const [events, setEvents] = useState([]);

  const web3Context = useContext(Web3Context);
  const contractsContext = useContext(ContractsContext);

  const {web3} = web3Context;
  const {contractNiftyEggsFarmer} = contractsContext;

  useEffect(() => {
    Logger.log("useEffect loadEvents");

    const loadEvents = async () => {
      if (contractNiftyEggsFarmer) {
        contractNiftyEggsFarmer.events.CreateFarm({
          fromBlock: 0
        })
          .on('data', function (event) {
            Logger.log(event);
            addEvent(event, 'created a new farm');
          })
          .on('changed', function (event) {
            Logger.log("changed", event);
            removeEvent(event.id)
          })
          .on('error', Logger.error);

        contractNiftyEggsFarmer.events.LockToken({
          fromBlock: 0
        })
          .on('data', function (event) {
            Logger.log(event);
            addEvent(event, 'locked the tokens');
          })
          .on('changed', function (event) {
            Logger.log("changed", event);
            removeEvent(event.id)
          })
          .on('error', Logger.error);

        contractNiftyEggsFarmer.events.ClaimToken({
          fromBlock: 0
        })
          .on('data', function (event) {
            Logger.log(event);
            addEvent(event, 'claimed the NFT!');
          })
          .on('changed', function (event) {
            Logger.log("changed", event);
            removeEvent(event.id)
          })
          .on('error', Logger.error);
      }
    };

    loadEvents();
  }, [web3, contractNiftyEggsFarmer]);

  const addEvent = (event, action) => {
    const values = event.returnValues;
    const newEvent = {
      id: event.id,
      timestamp: values._timestamp,
      who: values._who,
      txHash: event.transactionHash,
      action: action
    };
    setEvents(events => [...events, newEvent]);
  };

  const removeEvent = (id) => {
    setEvents(events => events.filter(item => item.id !== id));
  };

  const listItems = events
    .sort((a, b) => b.timestamp - a.timestamp)
    .map((item, index) =>
      <Event key={index} timestamp={item.timestamp} who={item.who} txHash={item.txHash} action={item.action}/>
    );

  return (
    <div className="px-4 py-5 container-fluid">
      <div className="row no-gutters">
        <div className="col-12 col-md-10 offset-md-1">
          <div className="text-center">
            <h2>Events</h2>
            <span className="text-warning">Explore all the events happening in NiftyEggs!</span>
          </div>
          <Container className="mt-5">
            {(listItems && listItems.length > 0) ?
              listItems
              :
              <div>Loading events...</div>
            }
          </Container>
        </div>
      </div>
    </div>
  )
};

export default Events;